import { put, call } from 'redux-saga/effects'
import { SET_LANGUAGE, SET_ANONYMOUS_INFO } from '../actions/type'
import i18n from '../../i18n'
import { getCookie } from '../../helpers'
import { isEmpty } from 'lodash'

function* setLocale() {
    const lng = getCookie('language')
    i18n.changeLanguage(lng)
    yield put({
        type: SET_LANGUAGE,
        payload: !isEmpty(lng) ? lng : 'th'
    })
}

function* setAnonymouseInfo() {
    const info = localStorage.getItem('anonymousInfo') ? JSON.parse(localStorage.getItem('anonymousInfo')) : {}
    if (!isEmpty(info)) {
        yield put({
            type: SET_ANONYMOUS_INFO,
            payload: {
                anonymousInfo: info
            }
        })
    }

}

function* startup() {
    localStorage.removeItem("vtoken")
    yield call(setLocale)
    yield call(setAnonymouseInfo)
}

export default startup